module.exports = __webpack_public_path__ + "img/indexc.5499ad0a.png";